import ReportsService from '@/services/apiRequests/reports.service';
import { s2ab } from '@/utils';

export default {
    namespaced: true,
    actions: {
        async getReportPreTrialNoticesIssued(_, args) {
            const response = await ReportsService.getReportPreTrialNoticesIssued(args.report_category, args.engineer_rid, args.period, args.sum_debt);
            if (!response.data) return false;

            const fileURL = window.URL.createObjectURL(new Blob([s2ab(atob(response.data))]));
            const fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'Отчет по выданным Досудебным уведомлениям.xlsx');
            document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();

            return true;
        },
        async getReportCreatedActs(_, args) {
            const response = await ReportsService.getReportCreatedActs(
                args.report_category,
                args.engineer_rid,
                args.period,
                args.action_type_rid,
                args.action_reason_rid
            );
            if (!response.data) return false;

            const fileURL = window.URL.createObjectURL(new Blob([s2ab(atob(response.data))]));
            const fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'Отчет по оформленным Актам на отключение / подключение.xlsx');
            document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();

            return true;
        }
    }
};
